import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import api from '../../../../../../services/api';
import { IconButton, Tooltip } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import './styles.css';

export default function PainelTriagemOcorrencias({ onSelectInstalacao }) {
    const [ocorrencias, setOcorrencias] = useState([]);

    useEffect(() => {
        carregarOcorrencias();
        const interval = setInterval(() => {
            carregarOcorrencias();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    async function carregarOcorrencias() {
        try {
            const token = Cookies.get('token');
            const headers = { Authorization: 'Bearer ' + token };
            
            // Verifica no futuro se tem id_cliente no cookie ou localStorage para chamar o endpoint especifico se for cliente
            // Por hora chamando o global (considerando acesso admin)
            const response = await api.get('/v1/protected/monitoramento/triagem-ocorrencias', { headers });
            const sortedData = response.data.sort((a, b) => {
                const dateA = new Date(a.data_hora_evento.replace(' ', 'T'));
                const dateB = new Date(b.data_hora_evento.replace(' ', 'T'));
                return dateB - dateA;
            });
            setOcorrencias(sortedData);
        } catch (error) {
            console.error("Erro ao buscar triagem de ocorrencias: ", error);
        }
    }

    const recentes = ocorrencias.filter(o => o.categoria_triagem === 1);
    const criticas = ocorrencias.filter(o => o.categoria_triagem === 2);
    const rearmadas = ocorrencias.filter(o => o.categoria_triagem === 3);

    const renderCard = (ocorrencia) => {
        let formattedDate = ocorrencia.data_hora_evento;
        try {
            const dateObj = new Date(ocorrencia.data_hora_evento.replace(' ', 'T'));
            if (!isNaN(dateObj)) {
                formattedDate = `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR', { hour: '2-digit', minute:'2-digit' })}`;
            }
        } catch (e) {}

        return (
            <div 
                key={ocorrencia.id} 
                className="triagem-card" 
                title={`Data/Hora: ${ocorrencia.data_hora_evento}\nZonas: ${ocorrencia.zonas_alarmadas}`}
                onClick={() => onSelectInstalacao && onSelectInstalacao({ id_instalacao: ocorrencia.id_instalacao })}
            >
                <div className="triagem-card-header">
                    <div className="triagem-card-mapa">{ocorrencia.nome_mapa}</div>
                    <Tooltip title="Gerenciar Instalação">
                        <IconButton 
                            size="small" 
                            className="triagem-card-icon-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (onSelectInstalacao) onSelectInstalacao({ id_instalacao: ocorrencia.id_instalacao });
                            }}
                        >
                            <ManageAccountsIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="triagem-card-cliente">{ocorrencia.nome_cliente}</div>
                <div className="triagem-card-data">🕒 {formattedDate}</div>
            </div>
        );
    };

    return (
        <div className="painel-triagem-container">
            <div className="triagem-coluna">
                <div className="triagem-coluna-header recentes">
                    Localidades Alarmadas Recentemente
                </div>
                <div className="triagem-coluna-body">
                    {recentes.map(renderCard)}
                    {recentes.length === 0 && <div className="triagem-empty">Nenhuma ocorrência</div>}
                </div>
            </div>

            <div className="triagem-coluna">
                <div className="triagem-coluna-header criticas">
                    Localidades Críticas
                </div>
                <div className="triagem-coluna-body">
                    {criticas.map(renderCard)}
                    {criticas.length === 0 && <div className="triagem-empty">Nenhuma ocorrência</div>}
                </div>
            </div>

            <div className="triagem-coluna">
                <div className="triagem-coluna-header rearmadas">
                    Alarmadas, Desarmadas e Rearmadas
                </div>
                <div className="triagem-coluna-body">
                    {rearmadas.map(renderCard)}
                    {rearmadas.length === 0 && <div className="triagem-empty">Nenhuma ocorrência</div>}
                </div>
            </div>
        </div>
    );
}
